import { createSelector } from 'reselect';

import { RootState } from "../..";
import { IndexableObjectType } from 'shared/types/common';

export const getEnclaves = (state: RootState) => state.enclaves;

export const getEnclaveList = (state: RootState) => state.enclaves.list;

export const getEnclaveMap = createSelector(
  getEnclaveList,
  (enclaves) => enclaves.reduce((enclaveMap: IndexableObjectType, enclave) => {
    enclaveMap[enclave.id] = enclave;

    return enclaveMap;
  }, {}),
);
